<template>
  <div>
    <!-- {{ "Items 1:" + JSON.stringify(items[0].items[0]) }} -->
    <!-- {{ "Items 2:" + items[0].items[0] }} -->
    <form @keypress="onFormKeypress">
      <DxForm
        :form-data.sync="formModel"
        :show-colon-after-label="false"
        :show-required-mark="false"
        :show-validation-summary="false"
        :scrolling-enabled="scrollingEnabled"
        :height="formHeight"
        :validation-group="validationGroup"
        :col-count-by-screen="{
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
        }"
        :label-location="formOptions.gcLabelLocation"
        :items.sync="items"
        ref="gc-form-comp"
        @content-ready="contentReady"
        :customizeItem="setCustomizeItem ? setCustomizeItem : customizeItem"
        :key="formKey"
        v-if="loaded"
        @editor-enter-key="onEditorEnterKey"
        :elementAttr="{
          class: formMode == 'filter-mode' ? 'gc-filter-form' : 'gc-form',
        }"
        @field-data-changed="onFieldDataChanged"
      >
        <!-- <template #item-template="{ data }">
          <GcAutoCompleteItemTemplate
            :description="data.Name"
            :code="data.Code"
          />
        </template> -->

        <template #gc-field-select-template="{ data }">
          <div>
            <gc-field-select-operator
              :selectBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
              :dataModel="formModel"
            ></gc-field-select-operator>
          </div>
        </template>

        <template #gc-tag-box-template="{ data }">
          <div>
            <gc-field-tag
              :tagBoxOptions="fieldItemOptionsForDependentField(data)"
              :valueChangeCallBack="wrappedValueCallback"
              :ignoreDataSourceFilter="false"
              :dataModel="formModel"
              :onPressEnterKey="onPressEnterKey"
            ></gc-field-tag>
          </div>
        </template>
        <template #image-uploader="{ data }">
          <gc-image-upload
            :dataModel="formModel"
            :imageUploaderOptions="data"
          ></gc-image-upload>
        </template>

        <template #gc-date-box-template="{ data }">
          <div>
            <gc-field-date
              :dateBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
              :onPressEnterKey="onPressEnterKey"
            ></gc-field-date>
          </div>
        </template>

        <template #gc-time-box-template="{ data }">
          <div>
            <gc-field-time
              :dateBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
              :onPressEnterKey="onPressEnterKey"
            ></gc-field-time>
          </div>
        </template>

        <template #gc-select-box-template="{ data }">
          <div>
            <gc-field-select
              :selectBoxOptions="fieldItemOptionsForDependentField(data)"
              :valueChangeCallBack="wrappedValueCallback"
              :onPressEnterKey="onPressEnterKey"
              :key="getChildFilterKey(data)"
            ></gc-field-select>
          </div>
        </template>

        <template #gc-check-box-template="{ data }">
          <div>
            <gc-field-check-box
              :checkBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
            ></gc-field-check-box>
          </div>
        </template>
        <template #DeliveryCompanyView>
          <div class="edit-address-btn">
            <span @click="deliveryAddressClicked(formModel)">
              <a>{{ deliveryLabel }}</a>
            </span>
          </div>
        </template>

        <template #gc-field-number-box-operator-template="{ data }">
          <div>
            <gc-field-number-select-operator
              :key="data.dataField"
              :numberBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
              :dataModel="formModel"
              :onPressEnterKey="onPressEnterKey"
            ></gc-field-number-select-operator>
          </div>
        </template>

        <template #gc-field-text-box-operator-template="{ data }">
          <div>
            <gc-field-text-box-operator
              :key="data.dataField"
              :textBoxOptions="fieldItemOptions(data)"
              :valueChangeCallBack="valueChangeCallBack"
              :dataModel="formModel"
              :onPressEnterKey="onPressEnterKey"
            />
          </div>
        </template>

        <!-- <template #DeliveryCompanyEdit="{ data }">
          <div class="edit-address-btn">
            <span @click="deliveryAddressClicked(formModel)">
              <a>{{ "Edit" }}</a>
            </span>
          </div>
        </template> -->

        <template #currency-template="{ data }">
          <GcAutoCompleteItemTemplate
            :description="data.Description"
            :code="data.CurrencyCode"
          />
        </template>

        <template #item-template="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{
              getPrimaryText(data)
            }}</span>
            <span class="auto-complete-secondary">
              {{ getSecondaryText(data) }}
            </span>
          </div>
        </template>

        <template #Record="{ data }">
          <GcRecord
            :data="{ data: data }"
            :primary="data['cellTemplateRecord']['primary']"
            :secondary="data['cellTemplateRecord']['secondary']"
          />
        </template>
      </DxForm>
    </form>

    <GcPopUpSelectRecord
      v-if="popupVisible"
      :popupVisible="popupVisible"
      :popupHiddenCallBack="popupHiddenCallBack"
      :popupConfig="popupConfig"
      :dataModel="undefined"
    />
  </div>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import { getDefaultDateSettings, getGlobalField } from "../_store/helpers";
import FormMixin from "@/_mixins/form.mixin";
import RouteMixin from "@/_mixins/route.mixin";
import gcImageUpload from "../components/gc-image-upload.vue";
// import { getFactorByCode } from "../_store/helpers";
import { getDecimalFormat } from "../_store/helpers";
import { GridReportService } from "../_services/api/reports/grid-report.service";
import { mapGetters } from "vuex";
import GcFieldTextBoxOperator from "./gc-field-text-box-operator";
import GcFieldTime from "./gc-field-time";

export default {
  components: { gcImageUpload, GcFieldTextBoxOperator, GcFieldTime },
  mixins: [FormMixin, RouteMixin],
  props: {
    formKey: {
      type: [String],
      default: "F1",
    },
    /**
     * form options (depend on the screen requirement)
     */
    formOptions: {
      type: [Object, Array],
      default: undefined, // might need to come up with default options
    },
    /**
     * form items
     */
    formItems: {
      type: [Object, Array],
      default: undefined,
    },

    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    deliveryAddressClicked: {
      // TODO: Please revisit.. does not seem right to have specific codes in gc-form control
      type: Function,
      default: () => function () {},
    },
    triggerClear: {
      type: Boolean,
      default: false,
    },
    formHeight: {
      type: [Number, String],
      default: "auto",
    },
    formLocation: {
      type: String,
      default: "grid-report",
    },
    checkValid: {
      type: Boolean,
      default: false,
    },
    isFilterForm: {
      type: Boolean,
      default: false,
    },
    isNormal: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    formMode: {
      type: String,
      default: "review",
    },
    getFormValidation: {
      type: Function,
      default: () => {},
    },
    checkValidation: {
      type: Boolean,
      default: false,
    },
    validationGroup: {
      type: String,
      default: "advanceFilterForm",
    },
    formContentReady: {
      type: Function,
      default: () => {},
    },
    formTitle: {
      type: String,
      default: "default-form",
    },
    scrollingEnabled: {
      type: Boolean,
      default: true,
    },
    persistenceKey: {
      type: String,
    },
    fromFrom: {
      type: String,
      default: undefined,
    },
    onFormEnterKey: {
      type: Function,
      default: () => {},
    },
    ignoreBaseVideMode: {
      type: Boolean,
      default: false,
    },
    setCustomizeItem: {
      type: Function,
      default: undefined,
    },
    fieldDataChanged: {
      type: Function,
      default: () => {},
    },
    onFormKeypress: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    //
    return {
      formModel: {},
      defaultValAvailable: false,
      currentFiscalYear: undefined,
      currentFiscalMonth: undefined,
      thisFiscalPeriod: undefined,
      deliveryLabel: "View",
      loaded: false,
      formData: undefined,
      defaultFilterTriggered: false,
      popupVisible: false,
      popupConfig: undefined,
      touchModalInstance: undefined,
      parentFilterValues: {},
      formReportFieldMapping: {},
    };
  },
  updated() {},
  watch: {
    triggerClear(val) {
      var form = this.$refs["gc-form-comp"].instance;
      if (val) {
        if (this.formMode == "filter-mode" && this.formData) {
          this.formModel = this.filterDataModel();
        }
        this.valueChangeCallBack("clear", []);
        form.resetValues();
        form.repaint(true);
      }
    },
    async checkValid(val) {
      if (val) {
        const mainForm = await validationEngine.validateGroup(
          this.validationGroup,
        );
        if (this.isNormal) {
          this.valueChangeCallBack(mainForm.isValid, mainForm.brokenRules);
        } else {
          if (mainForm.isValid) {
            this.valueChangeCallBack("apply", []);
          } else {
            this.valueChangeCallBack("isValid", false);
          }
        }
      }
    },
    dataModel: {
      handler(val) {
        if (this.isNormal && this.dataModel) {
          this.formModel = val;
        }
      },
      deep: true,
    },
    getHotKeyFilterFocus(value) {
      if (value) {
        if (this.formMode == "filter-mode") {
          this.$store.dispatch("hotKey/setHotKeyFilterFocus", false);
          var form = this.$refs["gc-form-comp"].instance;
          if (form && this.items[0].items.length > 0) {
            var editor = form.getEditor(this.items[0].items[0].dataField);
            if (editor) {
              editor.focus();
            }
          }
        }
      }
    },
  },
  async created() {
    this.defaultFilterTriggered = false;
    this.setCurrentFiscalData();
    // if (this.isNormal && this.formItems) this.createFormItems();

    // this.setCurrentFiscalYear();
    // this.formData = this.getFormItems;
  },
  computed: {
    ...mapGetters({ getHotKeyFilterFocus: "hotKey/getHotKeyFilterFocus" }),
    getKey() {
      return this.formKey;
    },
    getFormItems() {
      return this.formItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (
            globalField.isMultiValue === undefined &&
            c.isMultiValue != undefined
          )
            globalField.isMultiValue = c.isMultiValue;

          if (c.isYesNo) globalField.isYesNo = c.isYesNo;
          if (c.filterDataField) globalField.dataField = c.filterDataField;
          if (c.dupFilterDataField)
            globalField.dupDataField = c.dupFilterDataField;
          if (c.fieldName) globalField.fieldName = c.fieldName;
          if (c.type) globalField.type = c.type;

          if (!globalField.dataField || !globalField.fieldName) {
            // eslint-disable-next-line
            console.log(
              "%c GlobalField Not Found :",
              "background: #222; color: #bada55",
              c.screenField ? c.screenField : c.dataField,
            );
            return;
          }
          // globalField.filterIndex = c.filterIndex;
          if (c.dataSourceConfig) {
            globalField.dataSourceConfig = c.dataSourceConfig;
          }

          if (c.filterOverWrites) {
            globalField.dataSourceConfig = {
              ...globalField.dataSourceConfig,
              ...c.filterOverWrites,
            };
          }

          // if the global screen definition contains an filter value with [] the endpoint does not get triggered properly
          // therefore remove it
          if (
            globalField.dataSourceConfig &&
            globalField.dataSourceConfig.filter &&
            globalField.dataSourceConfig.filter.length == 0
          ) {
            delete globalField.dataSourceConfig.filter;
          }

          if (c.filterLabel) {
            globalField.filterLabel = c.filterLabel;
          }
          if (globalField.filterLabel) {
            globalField.label = globalField.filterLabel; // HACK: We will need to have a prop on form in the future to know when the form resides in the filter panel or elsewhere
          }

          if (c.filterEditorType)
            globalField.filterEditorType = c.filterEditorType;

          if (c.filterRequired) {
            // && this.formLocation != "grid-report"
            globalField.fieldRequired = c.filterRequired;
            globalField.validationMessageMode = "always";
          } else globalField.fieldRequired = false;
          globalField.formLocation = this.formLocation;

          if (c.filterDefaultValue) {
            globalField.filterDefaultValue = c.filterDefaultValue;
          } else if (c.defaultValue != undefined && c.defaultValue != null) {
            globalField.filterDefaultValue = c.defaultValue;
          }

          if (c.filterDataRelationship) {
            globalField.filterDataRelationship = c.filterDataRelationship;
          }

          if (c.filterDependsOn) {
            globalField.filterDependsOn = c.filterDependsOn;
          }

          if (c.filterOperator) {
            globalField.filterOperator = c.filterOperator;
          }

          if (globalField.filterDefaultValue) {
            if (
              globalField.type === "Boolean" &&
              (globalField.filterDefaultValue === false ||
                globalField.filterDefaultValue === true)
            ) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (Array.isArray(globalField.filterDefaultValue)) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (globalField.filterDefaultValue instanceof Date) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (
              globalField.type == "Integer" &&
              typeof globalField.filterDefaultValue == "number"
            ) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (
              globalField.type == "Integer" &&
              globalField.filterDefaultValue instanceof Object
            ) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (globalField.type == "Date") {
              if (globalField.filterDefaultValue instanceof Object)
                globalField.defaultValue = globalField.filterDefaultValue;
              else if (
                typeof globalField.filterDefaultValue !== "number" &&
                globalField.filterDefaultValue.toLowerCase() == "today"
              )
                globalField.defaultValue = new Date();
            } else if (
              globalField.filterOperator &&
              globalField.filterOperator == "between"
            ) {
              globalField.defaultValue = globalField.filterDefaultValue;
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() == "currentday"
            ) {
              globalField.defaultValue = [new Date().getDate()];
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() == "currentmonth"
            ) {
              globalField.defaultValue = [new Date().getMonth()];
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() == "currentyear"
            ) {
              globalField.defaultValue = [new Date().getFullYear()];
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() ==
                "currentfiscalyear" &&
              this.currentFiscalYear
            ) {
              globalField.defaultValue = [this.currentFiscalYear];
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() ==
                "currentfiscalmonth" &&
              this.currentFiscalMonth
            ) {
              globalField.defaultValue = [this.currentFiscalMonth];
            } else if (
              typeof globalField.filterDefaultValue !== "number" &&
              globalField.filterDefaultValue.toLowerCase() ==
                "thisfiscalperiod" &&
              this.thisFiscalPeriod
            ) {
              globalField.defaultValue = [this.thisFiscalPeriod];
            } else {
              globalField.defaultValue = globalField.filterDefaultValue;
            }
            this.isDefaultVal(true);
          }

          if (this.formLocation == "form-report") {
            if (c.screenField.match(/Cascading/)) {
              this.updateCascadingFields(globalField.dataField, c.screenField);
            }
            if (!c.screenField.match(/Cascading/)) {
              globalField.dataField = c.screenField;
            }
          }

          if (c.valueExpr) {
            globalField.valueExpr = c.valueExpr;
          }
          if (c.displayExpr) {
            globalField.displayExpr = c.displayExpr;
          }
          if (c.editorTemplate) {
            globalField.editorTemplate = c.editorTemplate;
          }

          if (c.filterOperators)
            globalField.filterOperators = c.filterOperators;

          if (c.multiSelect == false) globalField.multiSelect = c.multiSelect;

          if (c.intOperators) globalField.intOperators = c.intOperators;
          if (c.textOperators) globalField.textOperators = c.textOperators;
          if (c.negativePositive)
            globalField.negativePositive = c.negativePositive;

          if (c.touchEnabled) {
            globalField.touchEnabled = c.touchEnabled;
          }
          if (c.dateVariant) {
            globalField.dateVariant = c.dateVariant;
          }

          // if filterValueChangeEvent is set or type is Integer
          // set the valueChangeEvent to the filterValueChangeEvent or "input"
          if (
            c.filterValueChangeEvent ||
            c.type === "Integer" ||
            c.type == "Text"
          ) {
            if (!globalField.editorOptions) globalField.editorOptions = {};
            globalField.editorOptions.valueChangeEvent =
              c.filterValueChangeEvent || "input";
          }

          if (c.searchExpr) {
            globalField.searchExpr = c.searchExpr;
          }

          return globalField;
        })
        .filter((x) => x != null);
    },
    items() {
      return this.isNormal
        ? this.setFormItems
        : [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: this.formData
                ? this.formData.map((option) => {
                    let el = {};
                    if (option.dataField) {
                      el.label = { text: option.label };
                      el.dataField = option.dataField;
                      if (option.dupDataField)
                        el.dupDataField = option.dupDataField;
                      if (option.type == "Date" || option.type == "Time") {
                        if (option.dateVariant) {
                          el.dateVariant = option.dateVariant;
                        }
                        if (option.formLocation == "form-report") {
                          el.editorType = "dxDateBox";
                          el.editorOptions = {
                            validationMessageMode: "always",
                            displayFormat: "dd MMM yyyy",
                            onValueChanged: (e) => {
                              this.valueChangeCallBack(el.dataField, e.value);
                            },
                          };
                        } else {
                          if (option.type == "Time") {
                            el.template = "gc-time-box-template";
                          } else el.template = "gc-date-box-template";
                        }
                      } else if (option.formLocation == "form-report") {
                        if (option.type == "String") {
                          if (option.isMultiValue)
                            el.template = "gc-tag-box-template";
                          else el.template = "gc-select-box-template";
                        }
                        if (option.type == "Boolean") {
                          el.template = "gc-check-box-template";
                          el.editorOptions = {
                            labelLocation: "left",
                            rtlEnabled: true,
                          };
                          el.label = { visible: false };
                          el.cssClass = "form-report-checkbox";

                          if (option.defaultValue) {
                            el.value = option.defaultValue;
                          }
                        } else if (
                          (option.type == "Integer" ||
                            option.type === "Decimal") &&
                          !option.dataSourceConfig
                        ) {
                          el.editorType = "dxNumberBox";
                          el.cssClass = "filer-panel-numberbox";

                          el.editorOptions = {
                            onValueChanged: (e) => {
                              this.valueChangeCallBack(el.dataField, e.value);
                            },
                            onInitialized: () => {
                              if (option.defaultValue) {
                                this.valueChangeCallBack(
                                  option.dataField,
                                  option.defaultValue,
                                );
                              }
                            },
                            showClearButton: true,
                            placeholder: "Search " + option.label,
                            value:
                              option.defaultValue != undefined
                                ? option.defaultValue
                                : null,
                          };
                        } else {
                          if (option.isMultiValue)
                            el.template = "gc-tag-box-template";
                          else el.template = "gc-select-box-template";
                        }
                      } else if (
                        option.type == "Integer" ||
                        (option.type === "Decimal" &&
                          option.intOperators === true)
                      ) {
                        if (option.dataSourceConfig) {
                          el.template = "gc-select-box-template";
                        } else {
                          if (option.intOperators === true) {
                            el.template =
                              "gc-field-number-box-operator-template";
                          } else {
                            el.editorType = "dxNumberBox";
                          }
                          el.cssClass = "filer-panel-numberbox";

                          el.editorOptions = {
                            onValueChanged: (e) => {
                              this.valueChangeCallBack(el.dataField, e.value);
                            },
                            onInitialized: () => {
                              if (option.defaultValue) {
                                this.valueChangeCallBack(
                                  option.dataField,
                                  option.defaultValue,
                                );
                              }
                            },
                            showClearButton: true,
                            placeholder: "Search " + option.label,
                            value:
                              option.defaultValue != undefined
                                ? option.defaultValue
                                : null,
                          };
                        }
                      } else if (option.type == "Text") {
                        if (option.textOperators === true) {
                          el.template = "gc-field-text-box-operator-template";
                        }
                        el.editorType = "dxTextBox";
                        el.editorOptions = {
                          onValueChanged: (e) => {
                            this.valueChangeCallBack(
                              option.dupDataField
                                ? option.dupDataField
                                : el.dataField,
                              e.value,
                              option.type,
                            );
                          },
                          onInitialized: () => {
                            if (option.defaultValue) {
                              this.valueChangeCallBack(
                                option.dataField,
                                option.defaultValue,
                                option.type,
                              );
                            }
                          },
                          showClearButton: true,
                          placeholder: "Search " + option.label,
                          value:
                            option.defaultValue != undefined
                              ? option.defaultValue
                              : null,
                        };
                      } else if (
                        option.type == "Boolean" &&
                        option.isMultiValue === false
                      ) {
                        el.template = "gc-check-box-template";
                        el.editorOptions = {
                          labelLocation: "left",
                          rtlEnabled: true,
                        };
                        el.label = { visible: false };
                        el.cssClass = "gc-checkbox-template";

                        if (option.defaultValue) {
                          el.value = option.defaultValue;
                        }

                        el.isYesNo = option.isYesNo ? option.isYesNo : false;
                      } else el.template = "gc-tag-box-template";

                      el.formLocation = this.formLocation;

                      if (option.fieldRequired) {
                        el.validationRules = [
                          {
                            type: "required",
                            message: `${option.label} is required`,
                            validationMessageMode: "always",
                          },
                        ];
                      }

                      if (option.filterOperators)
                        el.template = "gc-field-select-template";

                      if (option.multiSelect == false)
                        el.template = "gc-select-box-template";

                      if (option.editorOptions) {
                        el.editorOptions = {
                          ...el.editorOptions,
                          ...option.editorOptions,
                        };
                      }

                      return el;
                    } else return el;
                  })
                : [],
            },
          ];
    },

    setFormItems() {
      var items = [];
      if (!this.formItems) return items;
      this.formItems.forEach((element) => {
        if (element.items && element.items.length > 0)
          this.formItemLoop(element.items);
        else this.getGlobal(element);
      });

      return this.formItems;
    },
  },

  methods: {
    updateCascadingFields(dataField, screenField) {
      this.formReportFieldMapping[dataField] = screenField;
    },

    // Normalises single-parent { parentField, filterParam } and multi-parent { parents: [...] }
    // formats into a uniform array of { parentField, filterParam, paramType? } objects.
    getFilterDependsOnParents(filterDependsOn) {
      if (filterDependsOn.parents) {
        return filterDependsOn.parents;
      }
      return [
        {
          parentField: filterDependsOn.parentField,
          filterParam: filterDependsOn.filterParam,
          paramType: filterDependsOn.paramType,
        },
      ];
    },
    // Returns all fields that transitively depend on dataField (direct children + grandchildren).
    getAllDescendants(dataField) {
      var self = this;
      var result = [];
      var seen = {};

      function collect(field) {
        if (!self.formData) return;
        self.formData.forEach(function (f) {
          if (!f.filterDependsOn || seen[f.dataField]) return;
          var parents = self.getFilterDependsOnParents(f.filterDependsOn);
          var isChild = parents.some(function (p) {
            return p.parentField === field;
          });
          if (isChild) {
            seen[f.dataField] = true;
            result.push(f);
            collect(f.dataField);
          }
        });
      }

      collect(dataField);
      return result;
    },
    wrappedValueCallback(dataField, filter, type) {
      let cascadingDataField = undefined;
      if (this.formReportFieldMapping[dataField]) {
        cascadingDataField = this.formReportFieldMapping[dataField];
      }

      if (this.formData) {
        var self = this;
        var descendants = this.getAllDescendants(dataField);
        if (descendants.length > 0) {
          var extractedValue = null;
          if (filter && filter.length > 0 && Array.isArray(filter[0])) {
            extractedValue = filter[0][2];
          }

          if (this.formLocation == "form-report") {
            extractedValue = filter;
          }
          this.$set(this.parentFilterValues, dataField, extractedValue);

          descendants.forEach(function (field) {
            var emptyValue = field.multiSelect === false ? null : [];
            self.$set(self.formModel, field.dataField, emptyValue);

            let casDataField = undefined;
            if (self.formReportFieldMapping[field.dataField]) {
              casDataField = self.formReportFieldMapping[field.dataField];
            }

            self.valueChangeCallBack(
              casDataField ? casDataField : field.dataField,
              emptyValue,
            );
            // Clear this field's own parentFilterValues entry so its children
            // don't inherit a stale value during cascade reset.
            self.$set(self.parentFilterValues, field.dataField, null);
          });
        }
      }
      this.valueChangeCallBack(
        cascadingDataField ? cascadingDataField : dataField,
        filter,
        type,
      );
    },
    fieldItemOptionsForDependentField(data) {
      var baseOptions = this.formData.filter(function (x) {
        return x.dataField === data.dataField;
      });

      if (!baseOptions.length || !baseOptions[0].filterDependsOn)
        return baseOptions;

      var fieldConfig = baseOptions[0];
      var self = this;
      var parents = this.getFilterDependsOnParents(fieldConfig.filterDependsOn);

      var parentConditions = [];
      var mergedFieldTypes = Object.assign(
        {},
        fieldConfig.dataSourceConfig && fieldConfig.dataSourceConfig.fieldTypes,
      );

      parents.forEach(function (parentDef) {
        var parentValue = self.parentFilterValues[parentDef.parentField];
        if (parentValue !== undefined && parentValue !== null) {
          parentConditions.push([parentDef.filterParam, "=", parentValue]);
          if (parentDef.paramType) {
            mergedFieldTypes[parentDef.filterParam] = parentDef.paramType;
          }
        }
      });

      if (parentConditions.length === 0) return baseOptions;

      var parentFilter;
      if (parentConditions.length === 1) {
        parentFilter = [parentConditions[0]];
      } else {
        parentFilter = [];
        parentConditions.forEach(function (cond, i) {
          parentFilter.push(cond);
          if (i < parentConditions.length - 1) parentFilter.push("and");
        });
      }

      var existingFilter =
        fieldConfig.dataSourceConfig && fieldConfig.dataSourceConfig.filter;
      var mergedFilter =
        existingFilter && existingFilter.length > 0
          ? [existingFilter, "and", parentFilter]
          : parentFilter;

      var updatedDataSourceConfig = Object.assign(
        {},
        fieldConfig.dataSourceConfig,
        {
          filter: mergedFilter,
        },
      );

      if (Object.keys(mergedFieldTypes).length > 0) {
        updatedDataSourceConfig.fieldTypes = mergedFieldTypes;
      }

      return [
        Object.assign({}, fieldConfig, {
          dataSourceConfig: updatedDataSourceConfig,
        }),
      ];
    },
    getChildFilterKey(data) {
      var fieldConfig =
        this.formData &&
        this.formData.find(function (x) {
          return x.dataField === data.dataField;
        });
      if (fieldConfig && fieldConfig.filterDependsOn) {
        var self = this;
        var parents = this.getFilterDependsOnParents(
          fieldConfig.filterDependsOn,
        );
        var keyParts = parents.map(function (p) {
          var pv = self.parentFilterValues[p.parentField];
          return pv !== null && pv !== undefined ? pv : "";
        });
        return data.dataField + "_" + keyParts.join("_");
      }
      return data.dataField;
    },
    clearFormModel() {
      var form = this.$refs["gc-form-comp"].instance;
      if (form) {
        this.defaultFilterTriggered = false;
        if (this.formMode == "filter-mode" && this.formData) {
          this.formModel = this.filterDataModel();
        }
        form.resetValues();
        form.repaint(true);
      }
    },
    async getFormValidations() {
      const mainForm = validationEngine.validateGroup(this.validationGroup);
      return mainForm;
    },
    isFormElementOfArrayType(el) {
      return (
        el.type == "String" && el.cellTemplate && el.cellTemplate == "Record"
      );
    },
    getFormDataModel() {
      return this.formModel;
    },
    formRepaint() {
      var form = this.$refs["gc-form-comp"].instance;
      form.repaint(true);
    },
    async setCurrentFiscalData() {
      // await GridReportService.requestData({
      //   url: "api/ReportFiscalPeriod",
      //   filter: "IsCurrentFiscalPeriod eq true",
      // })
      //   .then((res) => {
      //     var data = res.data.value[0];
      //     this.currentFiscalYear = data.FiscalYear;
      //     this.currentFiscalMonth = data.YearMonthId;
      //     this.thisFiscalPeriod = data.ThisFiscalPeriod;
      //     this.initialize();
      //   })
      //   .catch((err) => {
      //     if (err) this.initialize();
      //   });

      this.currentFiscalYear = getDefaultDateSettings().currentFiscalYear;
      this.currentFiscalMonth = getDefaultDateSettings().currentFiscalMonth;
      this.thisFiscalPeriod = getDefaultDateSettings().thisFiscalPeriod;
      this.initialize();
    },
    initialize() {
      this.formsConfig.formMode = this.formMode;

      if (this.formItems && this.formItems.length > 0)
        this.formData = this.getFormItems;
      if (this.isNormal && this.dataModel) {
        this.formModel = this.dataModel;
      }

      if (this.formMode == "filter-mode" && this.formData) {
        this.formModel = this.filterDataModel();
      }

      this.loaded = true;
    },

    filterDataModel() {
      let model = {};
      this.formData.forEach((el) => {
        let key = el.dataField;
        model[key] = this.isFormElementOfArrayType(el) ? [] : null;
      });

      return model;
    },
    getSecondaryText(data) {
      let globalField = { ...getGlobalField(data.screenField) };
      if (data.editorTemplate) globalField.editorTemplate = data.editorTemplate;

      return globalField.editorTemplate && globalField.editorTemplate.secondary
        ? data[globalField.editorTemplate.secondary[0].dataField]
        : undefined;
    },
    getPrimaryText(data) {
      let globalField = { ...getGlobalField(data.screenField) };

      return globalField.editorTemplate && globalField.editorTemplate.primary
        ? data[globalField.editorTemplate.primary[0].dataField]
        : undefined;
    },
    getDecimalFormatFromHelper(format) {
      return getDecimalFormat(format).EditFormat;
    },
    formItemLoop(items) {
      if (items[0].itemType != "group") {
        this.setGlobal(items);
      } else {
        items.forEach((element) => {
          if (element.items && element.items.length > 0)
            this.formItemLoop(element.items);
          else {
            if (element.screenField) {
              this.setGlobal([element]);
            }
          }
        });
      }
    },
    setGlobal(items) {
      return items
        .map((c) => {
          if (c.itemType != "group") {
            c.isNormal = this.isNormal;
            this.getGlobal(c);
          } else {
            this.setGlobal(c.items);
          }
        })
        .filter((x) => x != null);
    },
    getGlobal(c) {
      let globalField = { ...getGlobalField(c.screenField) };

      if (Object.keys(globalField).length > 0) {
        let fieldData = globalField.formField
          ? globalField.formField
          : globalField;

        c.dataField = c.dataField ? c.dataField : fieldData.dataField;
        c.label = c.label
          ? c.label
          : {
              text: fieldData.label,
              visible: c.labelVisible ? false : true,
            };
        if (!c.editorOptions) c.editorOptions = {};
        if (!c.editorOptions["maxLength"] && fieldData.maxLength)
          c.editorOptions["maxLength"] = fieldData.maxLength;

        if (fieldData.type == "switch") c.editorType = "dxSwitch";
        if (fieldData.type == "Date") {
          c.editorType = "dxDateBox";
          c.editorOptions.displayFormat = "dd MMM yyyy";
        }
        if (fieldData.type == "Decimal" || fieldData.type == "Number")
          c.editorType = "dxNumberBox";
        if (fieldData.type == "CheckBox" || fieldData.type == "Boolean")
          c.editorType = "dxCheckBox";
        if (c.type == "Decimal" || c.type == "Number")
          c.editorType = "dxNumberBox";

        if (c.dataSourceConfig) {
          globalField.dataSourceConfig = c.dataSourceConfig;
        }

        if (c.valueExpr) {
          globalField.valueExpr = c.valueExpr;
        }
        if (c.displayExpr) {
          globalField.displayExpr = c.displayExpr;
        }

        if (c.editorTemplate) {
          globalField.editorTemplate = c.editorTemplate;
        }

        // if (c.required) {
        //   // c.editorOptions["validationMessageMode"] = "always";
        //   c.validationRules = [
        //     {
        //       type: "required",
        //       message: `${c.label.text} is required`,
        //     },
        //   ];
        // }

        if (
          !this.ignoreBaseVideMode &&
          !this.baseView.mode == "review" &&
          !c.editorOptions.allowUpdate
        )
          c.required = false;
        else if (this.ignoreBaseVideMode && !c.editorOptions.allowUpdate)
          c.required = false;

        if (c.allowUpdate == false) {
          if (this.baseView.mode != "review")
            c.editorOptions["readOnly"] = true;
          else c.editorOptions["readOnly"] = false;
        }

        if (c.editAddress) this.deliveryLabel = "Edit";

        if (
          fieldData.cellTemplate &&
          c.allowUpdate != false &&
          !c.editorOptions["itemTemplate"]
        ) {
          c.template = fieldData.cellTemplate;
        }
        if (fieldData.format)
          if (fieldData.format.startsWith("Decimal")) {
            c.editorOptions["format"] = this.getDecimalFormatFromHelper(
              fieldData.format,
            );
          }

        // if (c.screenField == "Branch") {
        // primary key fields should not have a datsouurce to be selected from
        if (!c.isPrimaryKeyField && c.allowUpdate != false) {
          if (globalField.dataSourceConfig) {
            // console.log("<<<<<<<<<<<<<  ", c, " ", globalField);
            let filter = [];

            if (globalField.dataSourceConfig.filter)
              filter.push(globalField.dataSourceConfig.filter);
            if (c.filter)
              if (!filter) filter = c.filter;
              else {
                if (filter.length > 0) filter.push("and");
                filter.push(c.filter);
              }

            if (c.editorOptions.filter) {
              filter = c.editorOptions.filter;
            }

            if (c.editorType == "dxTagBox") {
              if (!c.editorOptions.displayedAllTags)
                c.editorOptions.maxDisplayedTags = 2;
              c.editorOptions.showMultiTagOnly = false;
            } else c.editorType = "dxSelectBox";

            if (globalField.dataSourceConfig.data) {
              globalField.dataSourceConfig.data.forEach((element) => {
                if (typeof element === "object" && element !== null) {
                  element.screenField = c.screenField;
                  element.cellTemplateRecord = c.cellTemplateRecord
                    ? c.cellTemplateRecord
                    : globalField.cellTemplateRecord;
                  element.formDataField = c.dataField;
                }
              });
              c.editorOptions.items = globalField.dataSourceConfig.data;
            } else {
              c.editorOptions.dataSource = GridReportService.dataSourceConfig(
                globalField.dataSourceConfig.endpoint,
                {
                  filter: filter.length != 0 ? filter : undefined,
                  select: c.editorOptions.select
                    ? c.editorOptions.select
                    : globalField.dataSourceConfig.select,
                  sort: globalField.dataSourceConfig.sort,
                  keyType: globalField.dataSourceConfig.keyType
                    ? globalField.dataSourceConfig.keyType
                    : c.editorOptions.keyType
                    ? c.editorOptions.keyType
                    : globalField.dataSourceConfig.keyType
                    ? globalField.dataSourceConfig.keyType
                    : undefined,
                  fieldType: c.editorOptions.fieldType
                    ? c.editorOptions.fieldType
                    : globalField.dataSourceConfig.fieldType
                    ? globalField.dataSourceConfig.fieldType
                    : undefined,
                  key: c.editorOptions.key
                    ? c.editorOptions.key
                    : globalField.dataSourceConfig.key
                    ? globalField.dataSourceConfig.key
                    : undefined,
                  postProcess: (data) => {
                    data.forEach((element) => {
                      if (c.screenField) element.screenField = c.screenField;
                      element.cellTemplateRecord = c.cellTemplateRecord
                        ? c.cellTemplateRecord
                        : globalField.cellTemplateRecord;
                      element.editorTemplate = c.editorTemplate
                        ? c.editorTemplate
                        : undefined;
                      element.formDataField = c.dataField;
                    });

                    return data;
                  },
                },
              );
            }

            c.editorOptions.valueExpr = globalField.valueExpr;
            c.editorOptions.displayExpr = globalField.displayExpr;
            c.editorOptions.searchExpr = c.searchExpr
              ? c.searchExpr
              : [globalField.valueExpr, globalField.displayExpr];
            c.editorOptions.searchMode = "contains";
            c.editorOptions.searchEnabled = true;
            if (globalField.editorTemplate || c.editorTemplate)
              c.editorOptions.itemTemplate = c.itemTemplate
                ? c.itemTemplate
                : globalField.itemTemplate
                ? globalField.itemTemplate
                : "item-template";
            if (c.defaultValue) c.editorOptions.value = c.defaultValue;
            c.template = undefined;

            // c.cellTemplateRecord = globalField.cellTemplateRecord;

            if (c.onValueChange)
              c.editorOptions.onValueChanged = c.onValueChange;

            if (c.onItemClick)
              c.editorOptions.onItemClick = c.onItemClick.bind(
                this,
                this.formModel,
              );

            if (c.acceptCustomValue)
              c.editorOptions.acceptCustomValue = c.acceptCustomValue;
            if (c.onCustomItemCreating)
              c.editorOptions.onCustomItemCreating = c.onCustomItemCreating;

            if (c.ref) c.editorOptions.ref = c.ref;
          }
        }

        if (c.displayExpr) {
          globalField.displayExpr = c.displayExpr;
        }
        // }

        if (c.validationRules && c.required) {
          c.validationRules.push({
            type: "required",
            message: `${c.label.text} is required`,
            validationMessageMode: "always",
          });
        } else if (c.required) {
          c.validationRules = [
            {
              type: "required",
              message: `${c.label.text} is required`,
              validationMessageMode: "always",
            },
          ];
          // c.editorOptions.validationMessageMode = "always";
        }

        let onFocusIn = undefined;
        if (c.editorOptions.onFocusIn) onFocusIn = c.editorOptions.onFocusIn;
        c.editorOptions.onFocusIn = (e) => {
          if (e && e.element) {
            var input = e.element.querySelector("input");
            if (input)
              input.setAttribute(
                "autocomplete",
                "new-input-" + e.name ? e.name : new Date().getTime(),
              );
          }

          if (onFocusIn) {
            onFocusIn(e);
          }
        };

        if (!c.editorTemplate && globalField.editorTemplate)
          c.editorTemplate = globalField.editorTemplate;

        if (c.touchEnabled) {
          let onFocusIn = undefined;
          if (c.editorOptions.onFocusIn) onFocusIn = c.editorOptions.onFocusIn;
          c.editorOptions.onFocusIn = (e) => {
            this.triggerTouchModal(e, c);
            if (onFocusIn) {
              onFocusIn(e);
            }
          };
        }

        return c;
      } else {
        // eslint-disable-next-line
        console.log(
          "%c GlobalField Not Found :",
          "background: #222; color: #da8655",
          c.screenField ? c.screenField : c.dataField,
        );

        if (!c.editorOptions) c.editorOptions = {};

        if (c.allowUpdate == false) {
          c.editorOptions["readOnly"] = true;
        }
        if (c.itemType != "group")
          c.dataField = c.dataField ? c.dataField : c.screenField;

        if (
          c.editorOptions.format != undefined &&
          !c.editorOptions.customFormat
        ) {
          if (c.editorOptions.format.startsWith("Decimal")) {
            c.editorOptions["format"] = this.getDecimalFormatFromHelper(
              c.editorOptions.format,
            );
          }
        }

        let onFocusIn = undefined;
        if (c.editorOptions.onFocusIn) onFocusIn = c.editorOptions.onFocusIn;
        c.editorOptions.onFocusIn = (e) => {
          if (e && e.element) {
            var input = e.element.querySelector("input");
            if (input)
              input.setAttribute(
                "autocomplete",
                "new-input-" + e.name ? e.name : new Date().getTime(),
              );
          }

          if (onFocusIn) {
            onFocusIn(e);
          }
        };

        if (c.validationRules && c.required) {
          c.validationRules.push({
            type: "required",
            message: `${c.label.text} is required`,
            validationMessageMode: "always",
          });
        } else if (c.required) {
          c.validationRules = [
            {
              type: "required",
              message: `${c.label.text} is required`,
              validationMessageMode: "always",
            },
          ];
          // c.editorOptions.validationMessageMode = "always";
        }

        // if (c.editorType == "dxDateBox") {
        //   if (c.touchEnabled) {
        //     if (c.editorType == "dxDateBox") {
        //       c.editorOptions.onFocusIn = (e) => {
        //         e.component.blur();
        //         setTimeout(() => {
        //           e.component.open();
        //         }, 50);
        //       };
        //     }
        //   }
        // }
        return c;
      }
    },
    // async setCurrentFiscalYear() {
    //   await this.$store.dispatch("screenFactors/getFactors", [75]);
    //   this.currentFiscalYear = getFactorByCode(75).FactorInt;
    // },
    isDefaultVal(val) {
      this.defaultValAvailable = val;
    },
    contentReady(e) {
      if (e) validationEngine.validateGroup(this.validationGroup);
      // if (this.defaultValAvailable && this.formLocation == "grid-report")
      //   this.onDefaultValueFilter();

      if (
        this.formLocation == "grid-report" &&
        this.formMode == "filter-mode" &&
        !this.defaultFilterTriggered
      ) {
        this.defaultFilterTriggered = true;
        setTimeout(() => {
          this.$emit("applyDefaultFilters");
        }, 500);
      }

      var headerForm = document.getElementsByClassName("gc-header-form")[0];
      var gcFooter = document.getElementsByClassName("gc-grid-footer")[0];
      if (headerForm)
        if (gcFooter)
          this.$store.dispatch(
            "ui/headerFormHeight",
            headerForm.clientHeight + 6,
          );
        else
          this.$store.dispatch("ui/headerFormHeight", headerForm.clientHeight);
      else this.$store.dispatch("ui/headerFormHeight", undefined);

      this.formContentReady(e);
    },
    onFieldDataChanged(e) {
      this.fieldDataChanged(e);
    },
    onEditorEnterKey() {
      this.onFormEnterKey();
    },
    onPressEnterKey() {
      this.onFormEnterKey();
    },

    fieldItemOptions(data) {
      return this.formData.filter((x) => {
        return x.dataField == data.dataField;
      });
    },

    // Select Box modal fro touch exp
    popupHiddenCallBack(show) {
      this.popupVisible = show;
      this.popupConfig = undefined;
      this.touchModalInstance.blur();
    },
    triggerTouchModal(e, fieldData) {
      this.touchModalInstance = e.component;

      if (
        fieldData.touchModalOptions &&
        fieldData.touchModalOptions.getUserDefaultRep
      )
        fieldData.editorOptions.dataSource.filter([
          "SalesRepresentativeCode",
          "=",
          fieldData.touchModalOptions.getUserDefaultRep,
        ]);

      if (fieldData.touchEnabled) {
        e.component.blur();
        this.popupConfig = {
          title: "Select " + fieldData.label.text,
          dataGrid: {
            toolbar: fieldData.touchModalOptions
              ? fieldData.touchModalOptions
              : {
                  salesrep: false,
                },
            options: {
              multipleSelect: false,
              // onRowClick: this.onCustomerRowClick,
              onRowClick: this.onRowClick,
              // selectedValues: this.selectedValues,
              keyExpr: fieldData.editorOptions.valueExpr,
            },
            dataSource: fieldData.editorOptions.items
              ? fieldData.editorOptions.items
              : fieldData.editorOptions.dataSource,
            columns: fieldData.editorTemplate
              ? [
                  {
                    caption: "Code",
                    dataField: "Code",
                    cellTemplate: (data, info) => {
                      return (data.innerHTML = `<div class="custom-auto-complete">
                              <span class="auto-complete-primary">
                                ${
                                  info.data[
                                    fieldData.editorTemplate.primary[0]
                                      .dataField
                                  ]
                                }
                              </span>
                              <span class="record-secondary gc-grid-code">
                                ${
                                  fieldData.editorTemplate.secondary
                                    ? info.data[
                                        fieldData.editorTemplate.secondary[0]
                                          .dataField
                                      ]
                                    : ""
                                }
                              </span>
                            </div>`);
                    },
                  },
                  {
                    caption: fieldData.editorTemplate.primary[0].dataField,
                    dataField: fieldData.editorTemplate.primary[0].dataField,
                    visible: false,
                  },
                ]
              : [],
          },
        };

        this.popupVisible = true;
      }
    },
    onRowClick(data, getKeyExpr) {
      this.popupHiddenCallBack(false);

      this.formModel[data.data.formDataField] = data.data[getKeyExpr];
    },
    updateFieldValue(dataField, value) {
      var form = this.$refs["gc-form-comp"].instance;
      var item = form.getEditor(dataField);
      if (item) {
        item.option("value", value);
      }
    },
    validateForm() {
      var form = this.$refs["gc-form-comp"].instance;
      if (form) form.validate();
    },
    getEditorField(dataField) {
      var form = this.$refs["gc-form-comp"].instance;
      if (form) return form.getEditor(dataField);
      else return false;
    },

    setFormFiledData(dataField, value) {
      var form = this.$refs["gc-form-comp"].instance;
      if (form) {
        form.getEditor(dataField).option("value", value);
      } else {
        this.formModel[dataField] = value;
      }
    },
  },
};
</script>

<style lang="scss">
form .dx-field-item-content .dx-state-disabled .dx-widget,
form .dx-field-item-content .dx-state-disabled.dx-widget {
  opacity: 1;
}

.dx-invalid.dx-texteditor.dx-show-invalid-badge
  .dx-texteditor-input-container:after {
  display: none;
}

.view-card .edit-address-btn {
  text-align: end;
}

.view-card .edit-address-btn span {
  cursor: pointer;
}

.dx-numberbox .dx-texteditor-input {
  text-align: right;
}
// .dx-invalid-message.dx-overlay-wrapper {

// }

.dx-scrollable-content > .dx-layout-manager {
  padding-right: 12px;
}

.dx-switch-on-value .dx-switch-container:before {
  background-color: rgba(3, 169, 244, 0.5) !important;
}

.dx-switch-on-value .dx-switch-handle:before {
  background-color: #03a9f4 !important;
}

.dx-invalid-message .dx-invalid-message-content {
  transform: translate(0px, 32px) !important;
}

.dx-field-item-label-text {
  color: #000000;
}
.bold-text .dx-texteditor-input {
  font-weight: bold;
}
.red-bold-text .dx-texteditor-input {
  font-weight: bold;
  color: red;
}

.filer-panel-numberbox {
  .dx-numberbox .dx-texteditor-input {
    text-align: left !important;
  }
}
</style>
